
import {Component, Vue} from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {getJobPositionList} from "@/api/job-position";
import {getRoles} from "@/api/role";
import {getUsersForAdmin} from "@/api/users";
import AccountsTypeForm from "./AccountsTypeForm.vue";
import ReceiptTypeForm from "./ReceiptTypeForm.vue";
import BatchAssignForm from "./BatchAssignForm.vue";

@Component({
  name: "setAccounts",
  components: {
    Pagination,
    AccountsTypeForm,
    ReceiptTypeForm,
    BatchAssignForm,
  }
})
export default class extends Vue {
  public options = {
    accountType: [
      {
        label: "A",
        value: "A"
      },
      {
        label: "B",
        value: "B"
      },
      {
        label: "A+B",
        value: "A_B"
      },
      {
        label: "无帐套",
        value: "NONE"
      }
    ],
    receiptType: [
      {
        label: "华强",
        value: "HQ"
      },
      {
        label: "嘉锐",
        value: "JR"
      },
      {
        label: "华强+嘉锐",
        value: "HQ_JR"
      },
      {
        label: "无单据",
        value: "NONE"
      }
    ],
  }

  public searchForm = [
    {
      label: "关键字",
      prop: "keyword",
      key: "keyword",
      type: "input",
      value: "",
      placeholder: "请输入关键字",
    },
    {
      label: "岗位",
      prop: "jobId",
      key: "jobId",
      type: "select",
      value: "",
      placeholder: "请选择",
      options: [],
      resetKey: {label: "label", value: "value"},
    },
    {
      label: "角色",
      prop: "roleId",
      key: "roleId",
      type: "select",
      value: "",
      placeholder: "请选择",
      options: [],
      resetKey: {label: "label", value: "value"},
    },
    {
      label: "帐套类型",
      prop: "accountType",
      key: "accountType",
      type: "select",
      value: "",
      placeholder: "请选择",
      options: this.options.accountType,
      resetKey: {label: "label", value: "value"},
    },
    {
      label: "单据类型",
      prop: "receiptType",
      key: "receiptType",
      type: "select",
      value: "",
      placeholder: "请选择",
      options: this.options.receiptType,
      resetKey: {label: "label", value: "value"},
    },
  ];

  public tableCol = [
    {
      label: "姓名",
      prop: "name",
      key: "name",
      show: true,
      disabled: false,
    },
    {
      label: "手机号",
      prop: "telephone",
      key: "telephone",
      show: true,
      disabled: false,
    },
    {
      label: "角色",
      prop: "role",
      key: "role",
      show: true,
      disabled: false,
    },
    {
      label: "岗位",
      prop: "job",
      key: "job",
      show: true,
      disabled: false,
    },
    {
      label: "帐套类型",
      prop: "accountType",
      key: "accountType",
      show: true,
      disabled: false,
    },
    {
      label: "单据类型",
      prop: "receiptType",
      key: "receiptType",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      account: ['ADMIN'],
      options: [
        {
          name: "修改帐套类型",
          code: "",
          click: "handleEditAccountType"
        },
        {
          name: "修改单据类型",
          code: "",
          click: "handleEditReceiptType"
        }
      ],
      show: true,
      disabled: false,
      width: 260,
    }
  ]

  private selectedUserIds = [];

  private listParam = {
    keyword: null,
    jobId: null,
    roleId: null,
    accountType: null,
    receiptType: null
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [],
  };

  async created() {
    await this.initJobPositions();
    await this.initRoles();
    this.getList();
  }


  private jobPositionIdAndNameMap = {} as { [key: string]: string };

  private async initJobPositions() {
    const data: any = await getJobPositionList();

    const jobOptions = [];
    const jobPositionIdAndNameMap = {};
    data.forEach((item: any) => {
      jobOptions.push({
        label: item.name,
        value: item.id
      })
      jobPositionIdAndNameMap[item.id] = item.name;
    })
    this.jobPositionIdAndNameMap = jobPositionIdAndNameMap;
    this.searchForm[1].options = jobOptions;
  }

  private roleIdAndNameMap: { [key: string]: string } = {};

  private async initRoles() {
    const data: any = await getRoles();
    const roleOptions = [];
    const roleIdAndNameMap = {};

    data.forEach((item: any) => {
      roleOptions.push({
        label: item.name,
        value: item.id
      })
      roleIdAndNameMap[item.id] = item.name;
    })
    this.roleIdAndNameMap = roleIdAndNameMap;
    this.searchForm[2].options = roleOptions;
  }

  private handleSelectionChange(val: any) {
    this.selectedUserIds = val.map((item: any) => item.id);
  }

  public querySearch(data: any) {
    this.table.pageNumber = 1;
    this.listParam = data && (data !== "reset" ? data : {});
    this.getList();
  }

  private dataLoading = false;

  private async getList() {
    this.dataLoading = true;
    const {total, content}: any = await getUsersForAdmin({
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize
    });
    content.map((item: any, index: number) => {
      item.sn = index + 1;
      item.role = this.roleIdAndNameMap[item.roleId];
      console.log(item)
      item.job = this.jobPositionIdAndNameMap[item.jobPositionId];
    });
    this.table.total = total;
    this.table.list = content;
    setTimeout(() => {
      this.dataLoading = false;
    }, 0.5 * 1000);
  }

  private handleBatchAssignment() {
    (this.$refs['batchAssignForm'] as BatchAssignForm)
        .handleBatchAssign(this.selectedUserIds)
  }

  private handleEditAccountType({row}) {
    (this.$refs['accountsTypeForm'] as AccountsTypeForm)
        .handleEditAccountType(row)
  }

  private handleEditReceiptType({row}) {
    (this.$refs['receiptTypeForm'] as ReceiptTypeForm)
        .handleEditReceiptType(row)
  }
}
